// Globals
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

// Store
import { useAppDispatch } from '@/store';

// Components
import { CollapseIcon, LogoMain } from '@/icons';
import { Image } from '@/ui';
import {
  StyledCollapseWrapper,
  StyledDesktopSideBarMenu,
  StyledDesktopSider,
  StyledLogoWrapper,
  StyledMenu,
} from './DesktopSideBarStyles';

// Modules
import { logOut, LogoutConfirmationModal } from '@/modules/Auth';
import { ProfileLinkContainer } from '@/modules/Profile';

// Helpers
import { useBoolean, useModal } from '@/hooks';
import { getActiveKey, getBottomMenuConfig, getTopMenuConfig } from '../../helpers';

const DesktopSideBar = () => {
  const { t } = useTranslation(['common']);

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const { value: collapsed, toggle: setCollapsed } = useBoolean();
  const { isOpened, openModal, closeModal } = useModal();

  const dispatch = useAppDispatch();
  const handleLogout = () => dispatch(logOut());

  const onPreventClick = (e: MouseEvent) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  return (
    <StyledDesktopSider width={'15rem'} collapsed={collapsed} onClick={setCollapsed}>
      <StyledLogoWrapper>
        {collapsed ? <Image src={'/favicon.ico'} alt={'logo'} preview={false} /> : <LogoMain />}
        <StyledCollapseWrapper $isCollapsed={collapsed}>
          <CollapseIcon />
        </StyledCollapseWrapper>
      </StyledLogoWrapper>
      <ProfileLinkContainer withName={!collapsed} onClick={onPreventClick} />
      <StyledMenu onClick={onPreventClick}>
        <StyledDesktopSideBarMenu
          selectedKeys={[getActiveKey(pathname)]}
          items={getTopMenuConfig(t, navigate)}
          $isCollapsed={collapsed}
        />
        <StyledDesktopSideBarMenu
          selectedKeys={[getActiveKey(pathname)]}
          items={getBottomMenuConfig(t, navigate, openModal)}
          $isCollapsed={collapsed}
        />
      </StyledMenu>
      <LogoutConfirmationModal isOpened={isOpened} onClose={closeModal} onLogout={handleLogout} />
    </StyledDesktopSider>
  );
};

export default DesktopSideBar;
